import {createContext} from "react";

export const Ev = createContext(false);